/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
//import {KTIcon, toAbsoluteUrl} from '../../../helpers'

type Props = {
  className: string
}

const TablesWidget10: React.FC<Props> = ({className}) => {
  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-center flex-column'>
            <label className='card-label fw-bold fs-2 mb-1'>Cliente</label>
        </h3>
      </div>

      {/* end::Header */}
      {/* begin::Body */}
      <div className='card-body py-3'>
        {/* begin::Table container */}
        <div className='table-responsive'>
          {/* begin::Table */}
          <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
            {/* begin::Table head */}
            <thead>
              <tr className='fw-bold text-muted'>
                
              </tr>
            </thead>
            {/* end::Table head */}
            {/* begin::Table body */}
            <tbody>
              <tr>
                <td>
                </td>
                <td>
                  <div className='text-align: center'>
                    <label className='card-label fw-bold '> ID de la cuenta: </label>
                    <span className='text-muted fw-semibold text-muted d-block fs-7'>
                        54956451539
                    </span>
                  </div>
                </td>
              </tr>

              <tr>
                <td>
                </td>
                <td>
                  <div className='text-align: center'>
                    <label className='card-label fw-bold '> SERVICE OWNER: </label>
                    <span className='text-muted fw-semibold text-muted d-block fs-7'>
                        Usuario -IT
                    </span>
                  </div>
                </td>
              </tr>

              <tr>
                <td>
                </td>
                <td>
                  <div className='text-align: center'>
                    <label className='card-label fw-bold '> Orden de compra: </label>
                    <span className='text-muted fw-semibold text-muted d-block fs-7'>
                        16161616161
                    </span>
                  </div>
                </td>
              </tr>

              <tr>
                <td>
                </td>
                <td>
                  <div className='text-align: center'>
                    <label className='card-label fw-bold '> SERVICE PERIOD: </label>
                    <span className='text-muted fw-semibold text-muted d-block fs-7'>
                        Desde: 12 de agosto 2023
                    </span>
                    <span className='text-muted fw-semibold text-muted d-block fs-7'>
                        Hasta: 12 de Septiembre 2023
                    </span>
                  </div>
                </td>
              </tr>

              <tr>
                <td>
                </td>
                <td>
                  <div className='text-align: center'>
                    <label className='card-label fw-bold '> Accoun Manager: </label>
                    <span className='text-muted fw-semibold text-muted d-block fs-7'>
                        Administrador de la cuenta
                    </span>
                  </div>
                </td>
              </tr>

              

            </tbody>
            {/* end::Table body */}
          </table>
          {/* end::Table */}
        </div>
        {/* end::Table container */}
      </div>
      {/* begin::Body */}
    </div>
  )
}

export {TablesWidget10}
